export default "__VITE_ASSET__D_SIW_0w__"